// extracted by mini-css-extract-plugin
export default {"component":"LW8GJ","bubble":"COThK","bubble__img":"ZUrGD"};